import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/$company/unternehmen/_fullscreen",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
